/*  ========================================================================
    # Components - Benefit Card
    ========================================================================  */

import React from "react";
import PropTypes from "prop-types";

export const BenefitCardSkeleton = () => {
  return (
    <div className="c-benefit-card c-benefit-card--skeleton">
      <div className="c-benefit-card__image" />
      <div className="c-benefit-card__content">
        <span />
        <div className="c-benefit-card__title" />
        <span />
        <span />
        <span />
        <div className="c-benefit-card__link" />
      </div>
    </div>
  );
};

export const BenefitCard = ({ baseUrl, offer }) => {
  const generateSlug = (url) => {
    return url
      .toLowerCase()
      .replaceAll("ä", "ae")
      .replaceAll("ö", "oe")
      .replaceAll("ü", "ue")
      .replaceAll("á", "a")
      .replaceAll("é", "e")
      .replaceAll("ó", "o")
      .replaceAll("ú", "u")
      .replaceAll("ß", "ss")
      .replaceAll("&", "")
      .replaceAll(" ", "-")
      .replaceAll("_", "")
      .replaceAll(".", "-")
      .replaceAll(",", "")
      .replaceAll('"', "")
      .replaceAll("%", "")
      .replaceAll("---", "-")
      .replaceAll("--", "-");
  };

  const getClosestLocation = (offer) => {
    if (offer?.siteClosest?.address)
      return offer.siteClosest.address.split(",")[1].trim();
    return null;
  };

  return (
    <a
      className="c-benefit-card"
      href={
        baseUrl +
        generateSlug(`${offer.campaign.title.trim()}/${offer.title.trim()}`)
      }
    >
      <figure className="c-benefit-card__image">
        {offer.images.length <= 0 ? (
          <div className="c-benefit-card__image-placeholder" />
        ) : (
          <img src={offer.images[0].location} alt={offer.title} />
        )}
        {offer.badge.trim() !== "" ? (
          <figcaption className="c-benefit-card__image-caption">
            {offer.badge}
          </figcaption>
        ) : null}
      </figure>
      <div className="c-benefit-card__content">
        {offer.siteDistance && !offer.geoUnrestricted ? (
          <span className="c-benefit-card__location">
            {getClosestLocation(offer)}
          </span>
        ) : null}
        {offer.siteDistance && offer.geoUnrestricted ? (
          <span className="c-benefit-card__location">online einlösbar</span>
        ) : null}
        <span>{offer.partner}</span>
        <h4>{offer.title}</h4>
        <p>{offer.excerpt}</p>
      </div>
    </a>
  );
};

BenefitCard.propTypes = {
  baseUrl: PropTypes.string,
  offer: PropTypes.object,
};
